import React, { useState } from 'react';
import './Option.css';

const Option = ({ title, features }) => {
  const [background, setBackground] = useState('');

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;

    const gradient = `radial-gradient(
        circle at ${xPercent}% ${yPercent}%,
#2c2f38,
#121216 160%
      )`;
    setBackground(gradient);
  };

  const handleMouseLeave = () => setBackground('');

  const handleClick = () => {
    const fragment = title === "GazeLead" ? "#gazelead" : "#splitlead";
    window.location.href = `/docs/mouse${fragment}`;
  };

  return (
    <div
      className="option"
      style={{ background }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <h2 className="option-title">{title}</h2>
      <ul className="option-list">
        {features.map((feature, index) => (
          <li key={index}>
            <span className="dot-mouse"></span> {feature}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Option;
